module.exports = __webpack_public_path__ + "img/Z71_11.7500f410.jpg";